import axios from "axios";
import {
  CreateScheduledMessage,
  ScheduledMessage,
  UpdateScheduledMessage,
  MessageStatus,
} from "../models/scheduledMessages.model";

/* --------------------------------------------------
   AXIOS INSTANCE
-------------------------------------------------- */

const BASE_URL = process.env.REACT_APP_REACT_APP_PYTHON_BACKEND_URL ||
  process.env.REACT_APP_PYTHON_BACKEND_URL ||
  "http://localhost:8000";

const api = axios.create({
  baseURL: `${BASE_URL}/admin/scheduled-messages`,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

/* --------------------------------------------------
   HELPERS
-------------------------------------------------- */

const handleError = (err: any) => {
  console.error("Scheduled Message API Error:", err);

  if (err.response) {
    throw new Error(err.response.data?.detail || "Server error");
  } else if (err.request) {
    throw new Error("Network error. Backend not reachable.");
  } else {
    throw new Error(err.message || "Unknown error");
  }
};

/* --------------------------------------------------
   LIST
-------------------------------------------------- */

export const getScheduledMessages = async (
  businessId: string
): Promise<ScheduledMessage[]> => {
  try {
    const res = await api.get<ScheduledMessage[]>(`/${businessId}`);
    return res.data;
  } catch (err) {
    handleError(err);
    return [];
  }
};

/* --------------------------------------------------
   CREATE
-------------------------------------------------- */

export const createScheduledMessage = async (
  payload: CreateScheduledMessage
): Promise<{ id: string }> => {
  try {
    const res = await api.post("/", payload);
    return res.data;
  } catch (err) {
    handleError(err);
    throw err;
  }
};

/* --------------------------------------------------
   UPDATE STATUS (CANCEL / RESCHEDULE)
-------------------------------------------------- */

export const updateScheduledMessageStatus = async (
  id: string,
  status: MessageStatus
) => {
  try {
    const payload: UpdateScheduledMessage = { status };
    const res = await api.put(`/${id}`, payload);
    return res.data;
  } catch (err) {
    handleError(err);
    throw err;
  }
};

/* --------------------------------------------------
   DELETE
-------------------------------------------------- */

export const deleteScheduledMessage = async (id: string) => {
  try {
    const res = await api.delete(`/${id}`);
    return res.data;
  } catch (err) {
    handleError(err);
    throw err;
  }
};
